import breakpointChecker from "../utils/breakpointChecker"
export default function shareSocial () {
  (function($) {
    $(document).ready(function() {
      $('body').delegate('.shareSocial', 'click', function() {
        $(this).toggleClass('shareSocial--active')
      }).delegate('.shareSocial', 'focus', function() {
        $(this).addClass('shareSocial--active')
      })
      $('body').delegate('.shareSocial__listItem:last-child a', 'blur', function() {
        $('.shareSocial').removeClass('shareSocial--active')
      })
    })
  })(window.hsvmJQuery)
}